import React from "react";
import Clock from "react-live-clock";
import moment from "moment";
import { useSelector } from "react-redux";
function CustomClock() {
  const timeZone = useSelector((state) => state.Auth.company);
  return (
    <div className="clock">
      <span className="time">
        <Clock
          format={"hh:mm A"}
          ticking={true}
          timezone={timeZone ? timeZone.TimeZone : "US/Pacific"}
        />
      </span>
      <br />
      <span className="day">{moment(new Date()).format("dddd, MMM DD")}</span>
    </div>
  );
}
export default React.memo(CustomClock);
